import { render, staticRenderFns } from "./lkuInventorycategory.vue?vue&type=template&id=6ad3e886"
import script from "./lkuInventorycategory.vue?vue&type=script&lang=js"
export * from "./lkuInventorycategory.vue?vue&type=script&lang=js"
import style0 from "./lkuInventorycategory.vue?vue&type=style&index=0&id=6ad3e886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports